export default "__VITE_ASSET__DJSfEFBa__"